<template>
  <tameo-sidebar-app-shell :menuItems="menuItems">
    <template v-slot:toolbarContent>
      <h1
        class="font-bold text-2xl pt-3 md:text-3xl md:pt-2 text-gray-700 flex-1"
      >
        Tameo's Funds KPIs
      </h1>
    </template>
    <template v-slot:sidebarTitle>
      <img src="./assets/tameo-logo.png" />
    </template>
    <router-view></router-view>
  </tameo-sidebar-app-shell>
</template>

<script lang="ts">
import { TameoSidebarAppShell } from 'tameo-vue-library'

export default {
  components: {
    TameoSidebarAppShell,
  },
  data() {
    return {
      menuItems: [
        { title: 'Home', url: '/', icon: 'home' },
        { title: 'Fund Reporting', url: '/fund-reporting', icon: 'tasks' },
        { title: 'FI Reporting', url: '/fi-reporting', icon: 'tasks' },
        {
          title: 'Financial Institutions',
          url: '/financial-institutions',
          icon: 'university',
        },
        {
          title: 'Reference Indexes',
          url: '/reference-indexes',
          icon: 'chart-line',
        },
        {
          title: 'Missing Fund reports',
          url: '/missing-fund-reports',
          icon: 'search',
        },
        {
          title: 'Detect suspicious variations',
          url: '/detect-suspicious-variations',
          icon: 'clipboard-check',
        },
        {
          title: 'Compare data sources',
          url: '/compare-data-sources',
          icon: 'not-equal',
        },
      ],
    }
  },
}
</script>

<style></style>
